class DubrinkError extends Error {
  constructor(msg, status, details) {
    super(msg);
    this.status = status;
    this.details = details;
  }
}

export default DubrinkError;
